import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/models/api-response';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { IdName } from 'src/app/shared/models/id-name';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { environment } from 'src/environments/environment';
import {
  INonConformanceTypeModel,
  INonConformanceTypeRequest,
} from '../../models/types/non-conformance-type.model';

@Injectable({
  providedIn: 'root',
})
export class NonConformanceTypesApiService {
  private get baseUrl(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/NonConformance/Types`;
  }

  private readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
    params: new HttpParams(),
  };

  constructor(private httpClient: HttpClient) {}

  getNonConformanceTypes(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<INonConformanceTypeModel[]>> {
    const params = createFilterParams(currentFilter);

    return this.httpClient.get<ApiResponse<INonConformanceTypeModel[]>>(this.baseUrl, {
      ...this.httpOptions,
      params,
    });
  }

  getAllNonConformanceTypes(): Observable<IdName[]> {
    const url = `${this.baseUrl}/List`;
    return this.httpClient.get<IdName[]>(url);
  }

  getNonConformanceTypeById(id: string): Observable<INonConformanceTypeModel> {
    const url = `${this.baseUrl}/${id}`;
    return this.httpClient.get<INonConformanceTypeModel>(url, this.httpOptions);
  }

  getNonConformanceTypeByVersionId(
    id: string,
    versionId: string
  ): Observable<INonConformanceTypeModel> {
    const url = `${this.baseUrl}/${id}/Versions/${versionId}`;
    return this.httpClient.get<INonConformanceTypeModel>(url, this.httpOptions);
  }

  createNonConformanceType(
    nonConformanceType: INonConformanceTypeRequest
  ): Observable<INonConformanceTypeModel> {
    return this.httpClient.post<INonConformanceTypeModel>(
      this.baseUrl,
      nonConformanceType,
      this.httpOptions
    );
  }

  updateNonConformanceType(
    nonConformanceType: INonConformanceTypeRequest
  ): Observable<INonConformanceTypeModel> {
    return this.httpClient.put<INonConformanceTypeModel>(
      this.baseUrl,
      nonConformanceType,
      this.httpOptions
    );
  }

  deleteNonConformanceType(id: string): Observable<void> {
    const url = `${this.baseUrl}/${id}`;
    return this.httpClient.delete<void>(url, this.httpOptions);
  }
}
